<template>
  <div>
    <div class="site-benefits">
      <div class="container">
        <div class="grid">
          <div class="benefits-media">
            <img :src="currentUrl + '/img/sale_page_single/' + item.section_value.benefits_photo" />
          </div>
          <div class="benefits-detail">
            <div v-html="item.section_value.benefits_text"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    item: { type: Object, required: true }
  },
  computed: {
    ...mapGetters(['currentUrl'])
  }
}
</script>

<style lang="scss" scoped>
</style>